import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-fixed-incentive-bonuses',
    name: 'pay-fixed-incentive-bonus',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-fixed-incentive-bonus')
  }
]
